import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "create-folder__wrapper" }
const _hoisted_2 = { class: "create-folder" }
const _hoisted_3 = { class: "create-folder__btns" }
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isInput.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "data-btn": "create",
              class: "profile__run create-folder-active",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editInput(true)))
            }, _toDisplayString(_ctx.Ti18N("account.createFolder.createFolder")), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              "data-btn": "cancel",
              class: "profile__run create-folder-cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editInput(false)))
            }, _toDisplayString(_ctx.Ti18N("account.createFolder.cancel")), 1))
      ]),
      (_ctx.isInput.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            ref: "titleFolder",
            type: "text",
            placeholder: _ctx.Ti18N('account.createFolder.nameOfFolder'),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)), ["enter"]))
          }, null, 40, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}